import { useContext } from "react";
import { CourseManagementDataContext, CourseManagementDataContextValue } from "../../providers/course-management-provider";
import { CourseEditorTabs } from './course-edit';
import { CourseViewPage } from './course-view';

export default function AdminDetailsSelector() {
    const ctx: CourseManagementDataContextValue | null = useContext<CourseManagementDataContextValue | null>(CourseManagementDataContext);
    const { mode } = ctx!;

    return (<>
        {mode === "view" ? <CourseViewPage /> : <CourseEditorTabs /> }
    </>);
}